import styled from '@emotion/styled';
import { Button } from '@material-ui/core';

const ViewReleaseButton = styled(Button)({
  marginLeft: -8
});

export default ViewReleaseButton;
